var _defs, _path, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPeopleWithGiftbox = function SvgPeopleWithGiftbox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291.07,
    height: 244.899,
    viewBox: "0 0 291.07 244.899",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff7f5;}.b{fill:#f7cc7f;}.c{fill:#9bc1f9;}.d{fill:#efefef;}.e{fill:#466eb6;}.f{fill:#50bfa5;}.g{fill:#fae0b2;}.h{fill:#f48c7f;}.i{fill:#fff3d9;}.j{fill:#fed333;}.k{fill:#f47458;}.l{fill:#f7a491;}.m{fill:#f47257;}.n{fill:#13375b;}.o{fill:#f8a492;}.p{fill:#b75742;}.q{fill:#def0f8;}.r{fill:#25706d;}.s{fill:#2d908c;}.t{fill:#fa957f;}.u{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M246.8,115.736c-10.227,15.845-8.419,37.368-4.037,54.338,1.467,5.682,3.161,11.674,1.857,18.042-1.6,7.785-7.312,13.922-13.085,17.434-10.527,6.407-22.512,6.276-31.191-.338-7.513-5.717-12.431-15.718-20.094-21.124-12.84-9.049-30.523-3.461-45.905,5.114-10.884,6.063-22.863,13.737-32.871,9.461-7.042-3.009-11.4-11.561-13.415-20.88-.972-4.5-1.548-9.413-3.806-12.837a14.6,14.6,0,0,0-5.12-4.5c-17.548-10.135-41.389-1.506-58.3-12.993C9.4,139.691,2.959,123.6.9,106.375S.662,70.695,2.935,52.525c1.626-12.91,3.809-26.736,10.9-37.262C21.332,4.128,29.276.212,43.3.119s19.039,7.2,26.645,14.774c9.507,9.467,18.061,21.573,30.406,24.588,8.4,2.054,17.611-.4,26.558-1.8,14.957-2.347,29.692-1.75,44.316-.952,14,.764,50.843-5.816,83.164,28.449,6.427,4.83,11.967,13.808,9.333,25.176C261.221,101.161,252.224,107.329,246.8,115.736Z",
    transform: "translate(291.086 208.219) rotate(172)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-407.55 -107.449)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(458.017 134.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1499.14,285.759c.037-.106.94-1.649,2.1-3.325,5.419-7.806,13.453-15.33,22.875-15.047l.007-.057a20.487,20.487,0,0,0-12.1,2.689c-6.045,3.259-11.934,9.468-15.157,14.241Z",
    transform: "translate(-1365.366 -258.123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1704.308,197.454l.638-4.39-3.255-3.014A.61.61,0,0,1,1702,189l4.373-.75,1.86-4.027a.61.61,0,0,1,1.093-.028l2.065,3.926,4.4.525a.61.61,0,0,1,.365,1.031l-3.1,3.177.862,4.352a.61.61,0,0,1-.868.665l-3.978-1.963-3.872,2.165A.61.61,0,0,1,1704.308,197.454Z",
    transform: "translate(-1547.645 -183.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M921.393,225.733l-.58,2.151,1.739,1.462-.821,2.365,2.332.986-.81,2.715,2.035,1.173-.352,2.74-1.037-.133.263-2.048-2.148-1.237.779-2.61-2.371-1,.906-2.609-1.7-1.428.538-1.993-1.311-.7.495-.921Z",
    transform: "translate(-850.468 -220.185)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.94 136.931)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M395.483,1440.134a6.817,6.817,0,1,1-9.628-.527A6.816,6.816,0,0,1,395.483,1440.134Z",
    transform: "translate(-383.588 -1437.866)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M427.773,1490.251a3.645,3.645,0,1,0,5.429-4.865Z",
    transform: "translate(-422.948 -1480.197)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1927.383,613.384l-1.179,2.939-4.939-1.375-2.254,4.085-3.864-.425-.215,1.956,5.168.568,2.136-3.871,5.138,1.43,1.774-4.423Z",
    transform: "translate(-1737.776 -566.483)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M364.121,856.129l-3.006.305-1.025-4.783-4.451-.1-1.353-3.454-1.749.685,1.809,4.62,4.218.091,1.067,4.976,4.524-.459Z",
    transform: "translate(-345.988 -775.57)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.364 42.485)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1754.086,576.035l1.888.623s2.993-.97,3.288-1.58.378-2.09.8-2.131a1.289,1.289,0,0,1,1.445,1.111c.143.735-.935,2.861-.766,3.087a10.306,10.306,0,0,0,1.97.8,1.471,1.471,0,0,1,.974,1.187v0a.81.81,0,0,1-.506.87l-.543.21.173.561a.809.809,0,0,1-.512,1l-.42.141.134.342a.809.809,0,0,1-.523,1.07l-.367.107.015.1a.809.809,0,0,1-.589.9l-.365.1-5.027-1.659a3.583,3.583,0,0,1-1.274-.74l-1.67-.881a.415.415,0,0,1-.195-.5l1.548-4.457A.413.413,0,0,1,1754.086,576.035Z",
    transform: "translate(-1751.997 -572.941)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M489.844,487.321c-.042-.119-1.049-1.841-2.35-3.712-6.049-8.715-15.019-17.114-25.538-16.8l-.008-.064a22.87,22.87,0,0,1,13.506,3c6.748,3.638,13.324,10.57,16.921,15.9Z",
    transform: "translate(-443.453 -435.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M373.855,388.737l-.712-4.9,3.634-3.365a.681.681,0,0,0-.347-1.17l-4.881-.838-2.077-4.5a.681.681,0,0,0-1.22-.031l-2.305,4.383-4.918.586a.681.681,0,0,0-.407,1.151l3.456,3.547-.962,4.858a.68.68,0,0,0,.969.743l4.441-2.191,4.323,2.416A.681.681,0,0,0,373.855,388.737Z",
    transform: "translate(-353.017 -352.857)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M292.6,619.925l1.148-1.939-.946-2.044a.31.31,0,0,1,.349-.432l2.2.492L297,614.47a.31.31,0,0,1,.519.2l.211,2.243,1.967,1.1a.31.31,0,0,1-.028.555l-2.068.894-.436,2.21a.31.31,0,0,1-.536.145l-1.489-1.69-2.237.268A.31.31,0,0,1,292.6,619.925Z",
    transform: "translate(-292.56 -567.377)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M2164.065,948.454l-2.754-.222-.375,2.547-2.722-.1-.659,2.389-2.049.259.131,1.037,2.74-.346.625-2.264,2.831.1.37-2.5,2.5.2Z",
    transform: "translate(-1952.081 -864.767)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M826.914,320.645l-.168-2.757-2.574-.013-.285-2.709-2.459-.316-.545-1.992-1.008.276.729,2.664,2.33.3.3,2.818,2.532.013.152,2.5Z",
    transform: "translate(-762.294 -298.773)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M327.281,1106.705l2.081.795,1.63-1.582,2.269,1.056,1.217-2.22,2.619,1.08,1.373-1.906,2.69.628-.237,1.018-2.011-.469-1.448,2.012-2.518-1.039-1.237,2.257-2.5-1.165-1.592,1.545-1.929-.736-.833,1.233-.866-.585Z",
    transform: "translate(-322.334 -1003.461)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1443.577,326.423l-.135,1.677-2.722.081-.5,2.428-2.027.394.2,1.026,2.712-.527.473-2.3,2.832-.084.2-2.524Z",
    transform: "translate(-1313.095 -310.857)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(172.381 13.647)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1884.538,311.045a7.88,7.88,0,1,1-11.142.232A7.881,7.881,0,0,1,1884.538,311.045Z",
    transform: "translate(-1871.203 -308.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1903.32,336.28l-3.353,1.031-1.052,3.346a.342.342,0,0,1-.606.094l-2.016-2.871-3.508.034a.342.342,0,0,1-.276-.547l2.107-2.8-1.116-3.326a.342.342,0,0,1,.435-.432l3.319,1.137,2.818-2.089a.342.342,0,0,1,.546.28l-.056,3.508,2.858,2.035A.342.342,0,0,1,1903.32,336.28Z",
    transform: "translate(-1890.12 -327.499)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M2164.924,662.34l1.848-.111a.273.273,0,0,0,.178-.437l-1.178-1.54.508-1.961a.247.247,0,0,0-.321-.313l-1.721.78-1.534-1.1a.247.247,0,0,0-.376.244l.114,2.022-1.455,1.281a.273.273,0,0,0,.088.464l1.791.47.635,1.892a.233.233,0,0,0,.431.043Z",
    transform: "translate(-1956.88 -605.883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M908.932,789.91s3.313-6.373,3.826-8.713S915,767.083,914.9,766.316c-.184-1.448-2.085-2.386-1.738-3.031s2.149-.845,2.762-.789a5.551,5.551,0,0,1,2.375.848c.528.435-.594,14.556-.929,17.6s-4.45,12.4-4.45,12.4Z",
    transform: "translate(-841.627 -699.304)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M992.614,767.931c-.073.046-.351.128-.417.187l-.509.161a3.046,3.046,0,0,1,2.081.8A3.525,3.525,0,0,0,992.614,767.931Z",
    transform: "translate(-915.346 -704.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1538.447,760.718a3.526,3.526,0,0,0,.885-2.007l.259-.835c-.2-.091-4.092-.83-5.273-.915a2.153,2.153,0,0,0-.177.886c.131.974,1.077,7.306,1.077,7.306l3.373.223S1538.028,761.621,1538.447,760.718Z",
    transform: "translate(-1398.561 -694.382)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1547.924,762.215a4.683,4.683,0,0,0-1.47,1.248s-1.852-1.312-1.768-1.7c.113-.51,2.02.534,2.02.534Z",
    transform: "translate(-1407.958 -698.537)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1706.156,1614.938s4.539,3.272,5.254,4.248c1.03,1.406-7.69,4.036-6.738,2.39.219-.379.847-1.653.874-1.778.146-.67-1.7-2.476-1.7-2.476Z",
    transform: "translate(-1549.736 -1458.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1681.1,1643.622l3.082-4.355a8.4,8.4,0,0,0,3.9-2.669,7.225,7.225,0,0,1,2.867,2.146,50.272,50.272,0,0,1-5.242,4.726,14.562,14.562,0,0,1-4.489,2.549C1678.612,1646.9,1681.1,1643.622,1681.1,1643.622Z",
    transform: "translate(-1528.523 -1477.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M1990.438,844.913s-1.174,1.936-1.3,1.818c-.1-.091.6-1.11,1.1-2.346.128-.318.253-.632.366-.921.3-.759-.069-1.153-.5-.406a8.392,8.392,0,0,0-.527,1.049,6.957,6.957,0,0,1-.549.955,9.12,9.12,0,0,1-.572.98c-.02-.034-.163.036-.037-.306.151-.41.659-1.214.837-1.834.1-.352.354-1.074.354-1.074a7.4,7.4,0,0,0,.123-1.194c-.338-.176-.682.586-.758,1.08a5.662,5.662,0,0,0-.451,1.061s-.834,1.446-1.033,1.332a19.093,19.093,0,0,1,.585-1.985c.242-.919.341-1.885.172-1.958-.287-.123-.661.87-.661.87s-.226.71-.319.94c-.109.27-.493,1.054-.493,1.054s-1.5,2.652-1.681,2.527a1.31,1.31,0,0,1-.433-.814c.035-.2.283-.525.319-.721a.486.486,0,0,0-.313-.537c-.231-.058-.755.831-.755.831a3.378,3.378,0,0,0-.432,1.305,4.362,4.362,0,0,0,.278,2.186,41.163,41.163,0,0,1-2.339,3.658l-.044.052,2.759,2.009c.921-1.5,1.636-2.67,1.845-3.037,0,0,1.385-1.184,2.231-1.957a10.023,10.023,0,0,0,1.529-2.138,10.592,10.592,0,0,0,1.18-2.226C1991.35,844.045,1990.438,844.913,1990.438,844.913Z",
    transform: "translate(-1796.957 -769.381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M1550.736,1300.478l-.718,3.551-18.048,16.416,12.919,13.074-3.489,3.565s-19.08-14.011-19.768-15.847c-1.059-2.827,13.677-21.551,13.677-21.551Z",
    transform: "translate(-1387.374 -1177.844)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1891.436,1704.849s4.538,3.272,5.253,4.248c1.03,1.406-7.689,4.036-6.738,2.39.219-.379.846-1.653.874-1.778.146-.671-1.7-2.476-1.7-2.476Z",
    transform: "translate(-1714.784 -1538.765)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1866.344,1734.328l3.082-4.355a7.85,7.85,0,0,0,4.023-2.59,6.631,6.631,0,0,1,2.744,2.067,50.308,50.308,0,0,1-5.242,4.726,14.558,14.558,0,0,1-4.489,2.549C1863.857,1737.606,1866.344,1734.328,1866.344,1734.328Z",
    transform: "translate(-1693.54 -1558.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1668.291,1310.558l.281,23.332,14.336,17.984-3.374,3.75s-17.753-14.76-19.7-19c-1.207-2.627-5.6-27.475-5.6-27.475Z",
    transform: "translate(-1505.547 -1186.278)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1648.892,1039.011c1.468-3.313,1.3-27.063,7.011-32.626,2.01.34,3.444.53,3.779.618.3,2.447.626,11.425.828,19.653.134,5.481,0,11.23.671,14.261C1661.6,1042.795,1647.551,1042.037,1648.892,1039.011Z",
    transform: "translate(-1500.706 -916.57)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1350.683,1115.483c-3.339.192-4.745.722-5.771.526s-3.765-1.173-3.716-2.2c3.667-.734,10.073.4,10.073.4C1350.829,1116.352,1350.683,1115.483,1350.683,1115.483Z",
    transform: "translate(-1226.689 -1012.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1450.594,1013.079s-1.482,7.28-3.208,8.531-10.479,5.651-11.016,5.62c-2.648-.154-15.308-.67-15.308-.67l.391-4.06,14.269-1.159s10.332-6.774,11.724-7.841A6.69,6.69,0,0,1,1450.594,1013.079Z",
    transform: "translate(-1297.834 -922.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1622.672,1040.3a7.2,7.2,0,0,1-2.613-.435s-.561-9.532,2.174-23.667c1.031-5.328,1.059-8.563,3.166-9.383a11.99,11.99,0,0,1,4.858-.731c-5.6,15.833-5.615,28.021-6.408,31.555C1623.451,1039.414,1623.1,1040.312,1622.672,1040.3Z",
    transform: "translate(-1475.059 -916.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1714.4,955.082l-.586,2.392s-.134,2.082.833,2.27c1.166.226,2.9-1.519,2.9-1.519l1-6.746Z",
    transform: "translate(-1558.617 -867.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1714.4,955.082l-.586,2.392s-.134,2.082.833,2.27c1.166.226,2.9-1.519,2.9-1.519l1-6.746Z",
    transform: "translate(-1558.617 -867.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1719.8,951.763l-4.138,3.572-.438,1.787A6.928,6.928,0,0,0,1719.8,951.763Z",
    transform: "translate(-1559.879 -867.913)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1692.722,894.919a2.443,2.443,0,0,0-2.253,1.69,21.217,21.217,0,0,0-.9,3.464c-.438,2.594,1.039,4.969,2.325,5.159a4.864,4.864,0,0,0,5.025-4.337c.291-1.575.672-3.642-.624-4.727A5.825,5.825,0,0,0,1692.722,894.919Z",
    transform: "translate(-1536.949 -817.276)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1695.067,876.256s4.531-4.038,4.729-7.193-2.716-4.845-5.208-4.933a16.93,16.93,0,0,0-3.049.157c-2.5.315-4.114,1.421-3.545,3.466.764,2.746,5.945.429,7,1.282.875.7-.543,2.395.306,3.04.8.607.392.4.127,1.554A20.343,20.343,0,0,0,1695.067,876.256Z",
    transform: "translate(-1535.518 -789.837)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1755.964,929.574c-.112.756-.574,1.314-1.032,1.246s-.738-.735-.626-1.491.575-1.314,1.032-1.247S1756.076,928.818,1755.964,929.574Z",
    transform: "translate(-1594.668 -846.813)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1567.163,753.03c-.407-.711-1.013.02-.62.944a.2.2,0,0,1,0,.109,6.524,6.524,0,0,1-1.044.995s.755,2.112,1.18,1.557a8.306,8.306,0,0,0,.747-2.355Z",
    transform: "translate(-1426.501 -690.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M1768.764,928.331l-3.086-3.054s-5.864,8.414-8.838,9.874c-2.891,1.419-12.517.9-12.855.826-1.154-.263-4.7-1.234-4.7-1.234s-2.975,25.534.9,34.412c1.264,2.9,9.128.976,9.128.976s-2.427-10.632-2.556-12.023c-.123-1.331-.8-11.876-.69-11.984.283-.284,11.018-2.623,13.96-4.859C1763.133,938.905,1768.764,928.331,1768.764,928.331Z",
    transform: "translate(-1580.336 -844.319)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.513 79.983)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M620.5,943.542c5.293,5.516,9.941.628,9.711.71a18.8,18.8,0,0,1,2.1-.1,8.579,8.579,0,0,0,7.276-5.377c4.718-.618,7.8-4.977,6.422-8.751,2.085-2.6,1.442-6.741-.53-9.4-.459-4.349-6.142-5.086-10.054-3.562a8.394,8.394,0,0,0-4.541,4.467,7.984,7.984,0,0,0-7.829,6.544C617.191,929.713,615.1,937.914,620.5,943.542Z",
    transform: "translate(-596.423 -916.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M938.282,1654.914a37.526,37.526,0,0,1-1.619,5.908c-.062.148-.653.69-.72.841.317,3.632,2.632,5.79,4.8,7.328-.472-1.832-1.521-3.933-1.385-4.34a52,52,0,0,1,2.845-7.33C940.4,1657.116,939.755,1656.017,938.282,1654.914Z",
    transform: "translate(-880.202 -1574.265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M794.328,1259.149l-12.557,8.574a85.655,85.655,0,0,1,8.213,5.97c2.1,2,13.317,11.062,13.5,11.52.136.34-1.041,4.638-3.739,18.4a13.8,13.8,0,0,0,5.377,2.81c3.263-7.342,6.947-22.618,6.534-24.3C811.012,1279.516,794.328,1259.149,794.328,1259.149Z",
    transform: "translate(-742.865 -1221.716)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M558.525,1381.156a51.463,51.463,0,0,1,3.752,7.688c1.365-.859,2.191-1.883,3.716-2.462a38.26,38.26,0,0,1-3.742-6.928c-.458-2.366-.995-2.714-.995-2.714s-7.931,2.683-8.459,3.435S557.042,1379.711,558.525,1381.156Z",
    transform: "translate(-538.857 -1326.468)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M544.029,1370.65c.615,0-.053-2.779-.194-3.42a1.2,1.2,0,0,0-.68-.962c-.281-.07-9.095,2.912-10.584,3.983a1.779,1.779,0,0,0-.309.353c-.816,1.522,6.45,1.811,7.5,1.146C540.687,1371.159,541.261,1370.643,544.029,1370.65Z",
    transform: "translate(-520.543 -1317.137)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M660,1252.9s-10.638-4.189-10.776-3.744c-1.1,3.548-4.529,2.4-6.563,8.652-.852,2.617-1.523,9.525-2.1,14.648-.395,3.521-.947,6.342-.947,6.342a95.783,95.783,0,0,0-7.1-8.865c-.359-.4-4.1,3.155-4.1,3.155,7.383,14.64,12.769,16.71,13.946,16.312,5.335-1.8,12.407-26.344,12.4-26.341C655.623,1261.369,660,1252.9,660,1252.9Z",
    transform: "translate(-606.254 -1212.785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M462.8,1023.894s-12.7-.016-15.419-.173c-2.461-.142-12.222.107-12.6.062s-2.9-4.317-3.324-3.858,1.4,2.119.84,2.549-6.621-.534-6.541-.086c.151.838,3.684.731,3.681,1.136s-3.7-.227-3.949.445,3.555.274,3.706.574-3.529.848-3.152,1.473c.2.339,3.261-.566,3.247-.1s-2.245,1.514-1.972,1.883,1.75-1.131,3.044-1.149,2.221-.694,4.286-.127c1.02.28,8.807,1.232,15.387,1.794,6.745.576,12.275.759,12.275.759Z",
    transform: "translate(-425.47 -1008.583)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M806.971,1010.308a43.539,43.539,0,0,0-.325-6.6c.617-2.118,1.929-6.637,2.4-7.525,0,0-2.211-4.249-4.475-4.22,0,0-2.311,5.21-4.1,6.143a4.447,4.447,0,0,1-.9.268c-1.726-.012-7.756-.2-8.881-.215l.633,8.555a26.738,26.738,0,0,1,1.524,13.82c-.233,1.081,10.239,4.325,11.847,3.289C804.762,1023.786,806.631,1014.43,806.971,1010.308Z",
    transform: "translate(-750.813 -983.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M739.362,1048.96c-1.112-.531-9.161-.265-9.161-.265s-1.125,5.605-.216,6.952c0,0,7.2,1.071,6.992,1.661Z",
    transform: "translate(-696.417 -1034.183)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M831.6,995.989a41.772,41.772,0,0,1,.988,4.216c.152,1.272,2.09,5.235,4.729,4.669s-.114-4.267-.631-5.433-1.914-5.875-1.914-5.875Z",
    transform: "translate(-787.253 -985.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M835.359,995.5c-.332-1.074-.586-1.931-.586-1.931l-3.172,2.424s.154.541.341,1.26A3.136,3.136,0,0,0,835.359,995.5Z",
    transform: "translate(-787.253 -985.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M794.136,931.313a4.483,4.483,0,0,0-1.869,2.478c-.485,1.684.158,6,3.776,6.994s5.128-2.457,4.347-5.125S797.946,929.624,794.136,931.313Z",
    transform: "translate(-752.089 -929.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M859.333,954.091c-.06.721-.449,1.276-.868,1.241s-.711-.647-.651-1.368.449-1.276.868-1.241S859.393,953.371,859.333,954.091Z",
    transform: "translate(-810.596 -948.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M912.028,1708.931c-.227-.572-2.525,1.25-3.067,1.62a1.2,1.2,0,0,0-.64.99c.039.28,5.885,7.479,7.595,8.475a.982.982,0,0,0,.6.058c.95-.366-.6-6.257-1.843-7.421A7.56,7.56,0,0,1,912.028,1708.931Z",
    transform: "translate(-855.594 -1622.285)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M783.819,932.965s-.583,4.836-2.131,5.73-.863,3.025-.863,3.025-1.488-4.951-.277-6.566A6.87,6.87,0,0,1,783.819,932.965Z",
    transform: "translate(-741.352 -931.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M788.291,985.812c.432.623.442,1.364.021,1.657s-1.112.024-1.545-.6-.442-1.364-.021-1.656S787.859,985.19,788.291,985.812Z",
    transform: "translate(-747.021 -977.588)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.427 14.622)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 27.508)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.769 0.421)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1321.014,573.556c-1.974.388-9.86,10.956-9.86,10.956l-.278.731s14.269-1.587,14.785-2.2C1327.057,581.4,1322.636,573.237,1321.014,573.556Zm-9.761,11.181c2.6-3.328,8.536-8.188,9.818-9.219a16.172,16.172,0,0,1,3.1,6.172C1322.529,582.027,1315.417,584.234,1311.254,584.737Z",
    transform: "translate(-1310.876 -573.547)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.804)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1147.185,571.922c-3.882-2.532-4.948-2.513-6.078-1.871s-5.3,6.625-3.438,8.492,16.651,3.2,16.651,3.2l.334-.9S1151.067,574.454,1147.185,571.922Zm-6.947,5.962c-.862-.86,1.284-4.442,2.263-5.2.25-.141,10.2,6.19,11.585,8.351C1148.535,580.429,1141.042,578.6,1140.239,577.884Z",
    transform: "translate(-1137.196 -569.688)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1.909,0h0A1.909,1.909,0,0,1,3.818,1.909V3.524A1.909,1.909,0,0,1,1.909,5.433h0A1.909,1.909,0,0,1,0,3.524V1.909A1.909,1.909,0,0,1,1.909,0Z",
    transform: "translate(37.553 9.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M1008.109,679.424l-67.644-.2a2.936,2.936,0,0,0-2.911,3.377l1.047,6.9,3.391-.007,2.043,34.736a3.516,3.516,0,0,0,3.509,3.31h53.99l2.246-38.175,3.194-.006Z",
    transform: "translate(-937.521 -667.261)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M942.638,766.164l.015-.834a9.953,9.953,0,0,0-1.789-.274l-.907-.669a.371.371,0,0,0-.457.334,1.381,1.381,0,0,0,.386.7s1.622,1.336,2.192,1.742c.282.2,1.171.743,1.171.743l.518-.968Z",
    transform: "translate(-939.284 -743.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1178.15,735.064h-41.442l-2.219-47.4h49.237l-2.065,44.1A3.488,3.488,0,0,1,1178.15,735.064Z",
    transform: "translate(-1112.981 -674.783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M1158.015,689.537l-53.452.142-1.22-10.284,52.362.2a2.935,2.935,0,0,1,2.912,3.2Z",
    transform: "translate(-1085.236 -667.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M1114.516,772.42l50.982-.142-49.365,2.7Z",
    transform: "translate(-1095.189 -750.157)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 1.418,
    height: 10.157,
    transform: "translate(39.385 12.059)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 1.773,
    height: 38.182,
    transform: "translate(43.499 22.169)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.303 16.46)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M950.622,471.7a115.039,115.039,0,0,0,12.487,4.1c1.279.34,3.4,1.308,4.573.446a1.393,1.393,0,0,0,.509-1.839c-.66-1.313-2.7-1.407-3.985-1.75-3.927-1.046-8.322-2.417-12.683-4.059a1.632,1.632,0,0,0-2,1.1,1.652,1.652,0,0,0,1.1,2Z",
    transform: "translate(-949.453 -468.508)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.052 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1199.059,330.165c-1.393-10.667-1.3-10.695-1.893-11.7a1.433,1.433,0,0,0-2.592.3c-.323,1.18-.25.992,1.258,12.21a1.674,1.674,0,0,0,2.02,1.208,1.7,1.7,0,0,0,1.208-2.02Z",
    transform: "translate(-1194.418 -317.772)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.848 3.612)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1369.548,361a24.669,24.669,0,0,0,2.676-4.561c.677-1.5,1.918-3.713.755-5.2a1.225,1.225,0,0,0-1.215-.342c-1.577.544-1.878,2.756-2.509,4.139a29.247,29.247,0,0,1-2.471,4.312,1.626,1.626,0,0,0,.556,2.209,1.647,1.647,0,0,0,2.208-.556Z",
    transform: "translate(-1366.55 -350.852)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.577 19.559)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1529.767,499.206a1.431,1.431,0,0,0-.484-1.923c-1.155-.862-3.192-.067-4.452.281a28.232,28.232,0,0,0-4.265,1.586,1.638,1.638,0,0,0-.612,2.214,1.665,1.665,0,0,0,2.214.612C1527.475,499.765,1528.589,500.823,1529.767,499.206Z",
    transform: "translate(-1519.755 -496.895)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M632.015,935.169a2.946,2.946,0,1,1,2.968,3.056A2.948,2.948,0,0,1,632.015,935.169Zm10.011-3.1,2.059-.029-8.669,12.238-2.059.029Zm-5.945,3.044c-.011-.813-.472-1.516-1.164-1.506-.727.01-1.1.708-1.086,1.538.012.813.472,1.516,1.164,1.506C635.722,936.639,636.093,935.924,636.081,935.111Zm3.462,6.146a2.946,2.946,0,1,1,2.968,3.056A2.948,2.948,0,0,1,639.543,941.258Zm4.066-.058c-.012-.813-.472-1.516-1.164-1.506-.727.01-1.1.708-1.086,1.538.012.813.472,1.516,1.164,1.506C643.25,942.728,643.621,942.013,643.609,941.2Z",
    transform: "translate(-53.478 -718.347)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPeopleWithGiftbox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/people_with_giftbox.ef65cdf9.svg";
export { ForwardRef as ReactComponent };